export default __webpack_public_path__ + "static/media/management.75e9871d.jpg";